module.exports = "/_next/static/images/2e5e7babd46831b2854aa026249aef54-payment_swipe.png.webp";